import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useWelcomeOffer } from '../../context/WelcomeOfferContext';
import { SANS } from '../../constants/fonts';

const s = {
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    flexWrap: 'wrap',
    padding: '16px 20px',
    background: 'linear-gradient(90deg, #4338ca, #818cf8)',
    color: '#fff',
    textDecoration: 'none',
    fontFamily: SANS,
    fontSize: 'clamp(0.85rem, 2.2vw, 0.95rem)',
    textAlign: 'center',
    cursor: 'pointer',
    boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
    transition: 'transform 0.4s ease, opacity 0.4s ease',
  },
  cta: {
    fontWeight: 700,
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
  },
};

function WelcomeOfferBanner() {
  const { offer } = useWelcomeOffer();
  const [visible, setVisible] = useState(false);
  const hasOffer = !!(offer && offer.offerType);

  useEffect(() => {
    if (!hasOffer) {
      setVisible(false);
      return;
    }
    const frame = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(frame);
  }, [hasOffer]);

  if (!hasOffer) return null;

  return (
    <Link
      to="/pricing"
      state={{ scrollToOffer: true }}
      style={{
        ...s.banner,
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(-10px)',
      }}
    >
      <span>
        <strong>{offer.name}</strong>, we've got a unique offer for you.
      </span>
      <span style={s.cta}>View your offer </span>
    </Link>
  );
}

export default WelcomeOfferBanner;
